import { defineComponent as _defineComponent } from 'vue'
import { useTHGGlobalStore } from '@/storenew/thg/global';
    import { useTHGCarStore } from '@/storenew/thg/cars';
    import { THGVehicleClass } from '@/enums/thg/THGVehicleClass';
    import { THGCarStatus } from '@/enums/thg/THGCarStatus';
    import { storeToRefs } from 'pinia';
    import { getCarStatusText, getVehicleClassText } from '@/utils/thg';
    import { ref } from 'vue';
    import readXlsxFile from 'read-excel-file';
    import { Country } from '@/enums/Country';
    import { THGCreateSource } from '@/enums/thg/THGCreateSource';
    import THGTagInput from '@/components/thg/THGTagInput.vue';
    import THGCarYearSelect from '@/components/thg/cars/THGCarYearSelect.vue';
    import { THGCarPayoffModel } from '@/enums/thg/THGCarPayoffModel';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'THGCarFilters',
  setup(__props) {

    const store = useTHGCarStore();
    const { currentCountry } = useTHGGlobalStore();
    const { filterParam } = storeToRefs(store);

    const acceptedFileTypes = [
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.ms-excel',
        '.xls',
        '.xlsx',
    ];

    const vinsFile = ref<File>();

    const onVinsFileChanged = (f: File) => {
        // clear the current vins array
        filterParam.value.vins = [];

        // clear the vin filter
        filterParam.value.vin = undefined;

        readXlsxFile(f).then((rows) => {
            // step 1: get the 'FIN' column index
            const finIndex = rows[0].findIndex((col) => {
                if (col) {
                    const colName = col.toString().toLowerCase();
                    const possibleNames = [
                        'fin',
                        'vin',
                        'fahrgestellnummer',
                        'fahrzeuggestellnummer',
                    ];

                    return possibleNames.includes(colName);
                }
            });

            if (finIndex === -1) {
                throw new Error('No FIN column found in excel file.');
            }

            // step 2: loop over rows and write fin column value to vins array, ignore first row of course
            for (const row of rows.slice(1)) {
                (filterParam.value.vins as string[]).push(row[finIndex].toString());
            }
        });
    };

    const clearFINs = () => {
        filterParam.value.vins = [];
        vinsFile.value = undefined;
    };
    const clearFIN = () => (filterParam.value.vin = '');
    const clearDriveCode = () => (filterParam.value.drive_code = '');
    const clearLicensePlate = () => (filterParam.value.license_plate = '');
    const clearUbaSubmittedDate = () => (filterParam.value.uba_submitted_date = undefined);
    const clearStartCreateDate = () => (filterParam.value.start_create_date = undefined);
    const clearEndCreateDate = () => (filterParam.value.end_create_date = undefined);
    const clearMailAddress = () => (filterParam.value.user_email = '');

return { __sfc: true,store, currentCountry, filterParam, acceptedFileTypes, vinsFile, onVinsFileChanged, clearFINs, clearFIN, clearDriveCode, clearLicensePlate, clearUbaSubmittedDate, clearStartCreateDate, clearEndCreateDate, clearMailAddress, THGVehicleClass, THGCarStatus, getCarStatusText, getVehicleClassText, Country, THGCreateSource, THGTagInput, THGCarYearSelect, THGCarPayoffModel }
}

})